import { FC } from "react";
import { useTagPicker } from "./TagPicker.hook";
import { TagList } from "./TagList";
import { Button } from "../../../../components/Button";
import { ErrorMessage } from "../../../../components/ErrorMessage";
import { Input } from "../../../../components/Input";
import { TagPickerProps } from "./TagPicker.types";
import "./style.css";

export const TagPicker: FC<TagPickerProps> = (props) => {
  const {
    tags,
    newTagControl,
    newTagError,
    onAddNewTagClick,
    onRemoveTagClick,
  } = useTagPicker(props);

  return (
    <form className="tag-picker-wrapper" onSubmit={onAddNewTagClick}>
      <Input name="newTag" label="Tags:" control={newTagControl} />
      <ErrorMessage error={newTagError} />
      <Button>Add tag</Button>
      <TagList tags={tags} onRemoveTagClick={onRemoveTagClick} />
    </form>
  );
};
